var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsNumber, IsString, IsUUID, ValidateNested } from 'class-validator';
import { Role } from '../../roles/index.js';
import { PreventionCourseVoucherFullSizeDto } from './prevention-course-voucher.full-size.dto.js';
export class PreventionCourseOverviewDto {
    id;
    title;
    thumbnailImage;
    price;
    shortDescription;
    longDescription;
    moduleCount;
    sectionCount;
    owned;
    preventionCourseVouchers;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseOverviewDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseOverviewDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PreventionCourseOverviewDto.prototype, "thumbnailImage", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], PreventionCourseOverviewDto.prototype, "price", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseOverviewDto.prototype, "shortDescription", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseOverviewDto.prototype, "longDescription", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], PreventionCourseOverviewDto.prototype, "moduleCount", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], PreventionCourseOverviewDto.prototype, "sectionCount", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], PreventionCourseOverviewDto.prototype, "owned", void 0);
__decorate([
    IsArray(),
    Type(() => PreventionCourseVoucherFullSizeDto),
    ValidateNested({ each: true }),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT] }),
    __metadata("design:type", Array)
], PreventionCourseOverviewDto.prototype, "preventionCourseVouchers", void 0);
//# sourceMappingURL=prevention-course-overview.full-size.dto.js.map